import { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "react-query";
import "./custom.css";
import "./App.css";
import "react-datepicker/dist/react-datepicker.css";
import "tw-elements";
import "react-toastify/dist/ReactToastify.css";
import toast, { Toaster } from "react-hot-toast";
import { CustomToastProvider } from "./components/customtoast/CustomToastProvider";
import ChatwootWidget from "./components/ChatwootWidget/ChatwootWidget";
import ContactSupportWidget from "./components/ContactSupportWidget/ContactSupportWidget";
import CandidateRoutes_ from "./pages/candidate/CandidateRoutes";
import ErrorBoundary from "../src/components/errorBoundary/errorBoundary";
import { UserContext } from "./context/index.js";
import LoginPage from "./pages/account/login";
import ForgotPassword from "./pages/account/forgotPassword";
import NotFoundPage from "./components/404Page/NotFoundPage.jsx";
import ChatbotWidget from "./components/ChatbotWidget/ChatbotWidget";
import TranslationLoader from "./components/TranslationLoader";
import Login from "./pages/account/login";
import CheckProfile from "./pages/account/CheckProfile";
import CultureAuditLogin from "./pages/account/CultureAuditLogin";
import PipelineJoin from "./pages/account/PipelineJoin";
import FAQs from "./pages/faq/FAQs";
import ExplainerVideo from "./pages/explainer-video/ExplainerVideo";

const queryClient = new QueryClient();

function App() {

  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const location = useLocation();
  const currentRoute = location.pathname;
  const queryParams = new URLSearchParams(location.search);
  const campaignId = queryParams.get("camapign_id");

  const [isOpen, setIsOpen] = useState(true);

  const toggleChat = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const userData = sessionStorage.getItem("user");
    if (userData) {
      const user = JSON.parse(userData);
      setUser((x) => ({ ...x, profile: user }));
    } else if (!userData && currentRoute.includes("/candidate")) {
      if (campaignId !== null)
        sessionStorage.setItem("profile-campaign-id", campaignId);
      navigate("/");
      toast.remove();
      toast("Login to your account");
    }
  }, []);

  const disabled = process.env.REACT_APP_DISABLE_ROUTE;

  // Culture audit is client-branded, so it gets an email-to-HR contact form
  // instead of our Chatwoot inbox (public/index.html skips Chatwoot for it
  // too). It needs the survey token and a campaign support inbox, so it only
  // shows once logged in to a campaign that has one.
  const isCultureAudit =
    currentRoute.startsWith("/survey/") ||
    sessionStorage.getItem("account_sub_type") === "culture";
  const showContactSupport =
    Boolean(sessionStorage.getItem("userToken")) &&
    sessionStorage.getItem("survey_support_enabled") === "1";

  return (
    <ErrorBoundary>
      <CustomToastProvider>
        <QueryClientProvider client={queryClient}>
          <UserContext.Provider value={{ user, setUser }}>
            <Routes>
              <Route path="/" element={<TranslationLoader>
                  <Login />
                </TranslationLoader>} /> 
              <Route
                path="/frequently-asked-questions"
                element={<TranslationLoader>
                  <FAQs />
                </TranslationLoader>}
              />
              <Route
                path="/explainer-video"
                element={<TranslationLoader>
                  <ExplainerVideo />
                </TranslationLoader>}
              />
              <Route
                path="/auth/forgot-password"
                element={<TranslationLoader><ForgotPassword /></TranslationLoader>}
              />
              <Route
                path="/auth/audit/check-profile/:pipeline_id/:assessment_id"
                element={<TranslationLoader><CheckProfile /> </TranslationLoader>}
              />
              <Route
                path="/survey/login"
                element={<TranslationLoader><CultureAuditLogin /></TranslationLoader>}
              />
              <Route
                path="/survey/login/:access_code"
                element={<TranslationLoader><CultureAuditLogin /></TranslationLoader>}
              />
              <Route
                path="/survey/join/:pipeline_id"
                element={<TranslationLoader><PipelineJoin /></TranslationLoader>}
              />
              <Route path="/candidate/*" element={<CandidateRoutes_ />} />
              <Route path="*" element={<NotFoundPage url={"/"} />} />
              <Route path="/" element={
                <TranslationLoader>
                  <LoginPage />
                </TranslationLoader>
              } />
            </Routes>
          </UserContext.Provider>
        
         {
/*
*/
isCultureAudit ? (showContactSupport && <ContactSupportWidget />) : <ChatwootWidget />
}
{/* <SupportWidget/> */}

{/* <button onClick={e=>window.$chatwoot.toggle()}>
  CLick
</button> */}

          {/* <ChatbotWidget
            src="https://bot.serviceschoolhouse.com/99472f4d-bf99-4804-8455-36a515979678/chatbot" /> */}
          {/*<ReactQueryDevtools initialIsOpen={false} position="bottom-left" />*/}
        
        </QueryClientProvider>
        <Toaster
          toastOptions={{
            // style: {
            //   color: "#023047",
            // },
            success: {
              iconTheme: {
                primary: "#90EE90",
              },

              style: {
                color: "#023047",
              },
              duration: 6000,
            },
            error: {
              duration: 5000,
            },
          }}
        />
      </CustomToastProvider>
    </ErrorBoundary>
  );
}

export default App;
